"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var sites = {
  admin: {
    development: {
      protocol: 'https',
      subdomain: 'admin',
      boundPort: 3002
    },
    test: {
      protocol: 'https',
      subdomain: 'admin-test',
      boundPort: 3003
    },
    staging: {
      protocol: 'https',
      subdomain: 'admin'
    },
    production: {
      protocol: 'https',
      subdomain: 'admin'
    }
  },
  'availability-api': {
    development: {
      protocol: 'https',
      subdomain: 'availability-api',
      boundPort: 8060
    },
    test: {
      protocol: 'https',
      subdomain: 'availability-api-test',
      boundPort: 8061
    },
    staging: {
      protocol: 'https',
      subdomain: 'availability-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'availability-api'
    }
  },
  'bringg-domain-events-adapter': {
    development: {
      protocol: 'https',
      subdomain: 'bringg-domain-events-adapter',
      boundPort: 9200
    },
    test: {
      protocol: 'https',
      subdomain: 'bringg-domain-events-adapter-test',
      boundPort: 9201
    },
    staging: {
      protocol: 'https',
      subdomain: 'bringg-domain-events-adapter'
    },
    production: {
      protocol: 'https',
      subdomain: 'bringg-domain-events-adapter'
    }
  },
  'catalog-api': {
    development: {
      protocol: 'https',
      subdomain: 'catalog-api',
      boundPort: 9130
    },
    test: {
      protocol: 'https',
      subdomain: 'catalog-api-test',
      boundPort: 9131
    },
    staging: {
      protocol: 'https',
      subdomain: 'catalog-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'catalog-api'
    }
  },
  'contentful-domain-events-adapter': {
    development: {
      protocol: 'https',
      subdomain: 'contentful-domain-events-adapter',
      boundPort: 9180
    },
    test: {
      protocol: 'https',
      subdomain: 'contentful-domain-events-adapter-test',
      boundPort: 9181
    },
    staging: {
      protocol: 'https',
      subdomain: 'contentful-domain-events-adapter'
    },
    production: {
      protocol: 'https',
      subdomain: 'contentful-domain-events-adapter'
    }
  },
  'drive-api': {
    development: {
      protocol: 'https',
      subdomain: 'drive',
      boundPort: 9110
    },
    test: {
      protocol: 'https',
      subdomain: 'drive-test',
      boundPort: 9111
    },
    staging: {
      protocol: 'https',
      subdomain: 'drive'
    },
    production: {
      protocol: 'https',
      subdomain: 'drive'
    }
  },
  'drive-ui': {
    development: {
      protocol: 'https',
      subdomain: 'drive',
      boundPort: 9110
    },
    test: {
      protocol: 'https',
      subdomain: 'drive-test',
      boundPort: 9111
    },
    staging: {
      protocol: 'https',
      subdomain: 'drive'
    },
    production: {
      protocol: 'https',
      subdomain: 'drive'
    }
  },
  'employees-api': {
    development: {
      protocol: 'https',
      subdomain: 'employees-api',
      boundPort: 8010
    },
    test: {
      protocol: 'https',
      subdomain: 'employees-api-test',
      boundPort: 8011
    },
    staging: {
      protocol: 'https',
      subdomain: 'employees-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'employees-api'
    }
  },
  'employees-ui': {
    development: {
      protocol: 'https',
      subdomain: 'employees',
      boundPort: 8005
    },
    test: {
      protocol: 'https',
      subdomain: 'employees-test',
      boundPort: 8006
    },
    staging: {
      protocol: 'https',
      subdomain: 'employees'
    },
    production: {
      protocol: 'https',
      subdomain: 'employees'
    }
  },
  'fulfillment-options-api': {
    development: {
      protocol: 'https',
      subdomain: 'fulfillment-options-api',
      boundPort: 9040
    },
    test: {
      protocol: 'https',
      subdomain: 'fulfillment-options-api-test',
      boundPort: 9041
    },
    staging: {
      protocol: 'https',
      subdomain: 'fulfillment-options-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'fulfillment-options-api'
    }
  },
  'fulfillment-options-ui': {
    development: {
      protocol: 'https',
      subdomain: 'fulfillment-options',
      boundPort: 9120
    },
    test: {
      protocol: 'https',
      subdomain: 'fulfillment-options-test',
      boundPort: 9121
    },
    staging: {
      protocol: 'https',
      subdomain: 'fulfillment-options'
    },
    production: {
      protocol: 'https',
      subdomain: 'fulfillment-options'
    }
  },
  'fulfillment-ui': {
    development: {
      protocol: 'https',
      subdomain: 'fulfillment',
      boundPort: 9030
    },
    test: {
      protocol: 'https',
      subdomain: 'fulfillment-test',
      boundPort: 9031
    },
    staging: {
      protocol: 'https',
      subdomain: 'fulfillment'
    },
    production: {
      protocol: 'https',
      subdomain: 'fulfillment'
    }
  },
  garbanzo: {
    development: {
      protocol: 'https',
      subdomain: 'www',
      boundPort: 3000
    },
    test: {
      protocol: 'https',
      subdomain: 'www-test',
      boundPort: 3001
    },
    staging: {
      protocol: 'https',
      subdomain: 'www'
    },
    production: {
      protocol: 'https',
      subdomain: 'www'
    }
  },
  'garbanzo-api': {
    development: {
      protocol: 'https',
      subdomain: 'api',
      boundPort: 3000
    },
    test: {
      protocol: 'https',
      subdomain: 'api-test',
      boundPort: 3001
    },
    staging: {
      protocol: 'https',
      subdomain: 'api'
    },
    production: {
      protocol: 'https',
      subdomain: 'api'
    }
  },
  // NOTE: ideally all these `highjump-api` entries would have a `path` of "/highjumpjsonrest/api/WarehouseAdvantage",
  // but there are limitations in goodeggs-http-api-contract-test-helper that make the use of this feature painful
  // (until that limitation is addressed). See https://github.com/goodeggs/goodeggs-sites/pull/25.
  'highjump-api': {
    development: {
      protocol: 'https',
      subdomain: 'hj-dev',
      domain: 'goodeggs.com',
      port: 8443
    },
    test: {
      protocol: 'https',
      subdomain: 'hj-dev',
      domain: 'goodeggs.com',
      port: 8443
    },
    staging: {
      protocol: 'https',
      subdomain: 'hj-stage',
      domain: 'goodeggs.com'
    },
    production: {
      protocol: 'https',
      subdomain: 'hj',
      domain: 'goodeggs.com'
    }
  },
  'highjump-domain-events-adapter': {
    development: {
      protocol: 'https',
      subdomain: 'highjump-domain-events-adapter',
      boundPort: 9170
    },
    test: {
      protocol: 'https',
      subdomain: 'highjump-domain-events-adapter-test',
      boundPort: 9171
    },
    staging: {
      protocol: 'https',
      subdomain: 'highjump-domain-events-adapter'
    },
    production: {
      protocol: 'https',
      subdomain: 'highjump-domain-events-adapter'
    }
  },
  'highjump-ui': {
    development: {
      protocol: 'https',
      subdomain: 'gdedevweb',
      domain: 'highjumpcloud.com'
    },
    test: {
      protocol: 'https',
      subdomain: 'gdedevweb',
      domain: 'highjumpcloud.com'
    },
    staging: {
      protocol: 'https',
      subdomain: 'gdetestweb',
      domain: 'highjumpcloud.com'
    },
    production: {
      protocol: 'https',
      subdomain: 'gdeprodweb',
      domain: 'highjumpcloud.com'
    }
  },
  'it-accounts-api': {
    development: {
      protocol: 'https',
      subdomain: 'it-accounts-api',
      boundPort: 9060
    },
    test: {
      protocol: 'https',
      subdomain: 'it-accounts-api-test',
      boundPort: 9061
    },
    staging: {
      protocol: 'https',
      subdomain: 'it-accounts-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'it-accounts-api'
    }
  },
  'it-accounts-ui': {
    development: {
      protocol: 'https',
      subdomain: 'it-accounts-ui',
      boundPort: 9050
    },
    test: {
      protocol: 'https',
      subdomain: 'it-accounts-ui-test',
      boundPort: 9051
    },
    staging: {
      protocol: 'https',
      subdomain: 'it-accounts-ui'
    },
    production: {
      protocol: 'https',
      subdomain: 'it-accounts-ui'
    }
  },
  kale: {
    development: {
      protocol: 'https',
      subdomain: 'ops',
      boundPort: 8000
    },
    test: {
      protocol: 'https',
      subdomain: 'ops-test',
      boundPort: 8001
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops'
    }
  },
  'kodif-domain-events-adapter': {
    development: {
      protocol: 'https',
      subdomain: 'kodif-domain-events-adapter',
      boundPort: 9230
    },
    test: {
      protocol: 'https',
      subdomain: 'kodif-domain-events-adapter-test',
      boundPort: 9231
    },
    staging: {
      protocol: 'https',
      subdomain: 'kodif-domain-events-adapter'
    },
    production: {
      protocol: 'https',
      subdomain: 'kodif-domain-events-adapter'
    }
  },
  login: {
    development: {
      protocol: 'http',
      subdomain: 'developer-login',
      boundPort: 9140,
      port: 9140
    },
    test: {
      protocol: 'http',
      subdomain: 'ops',
      boundPort: 8001,
      port: 8001
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops'
    }
  },
  // NOTE: Marketplace Web App does not actually currently have staging or production server
  // instances. MWA does have a server that runs during local development, but outside of the dev
  // environment it only outputs static assets.
  'marketplace-web-app': {
    development: {
      protocol: 'https',
      subdomain: 'mwa',
      boundPort: 4000
    },
    test: {
      protocol: 'https',
      subdomain: 'mwa-test',
      boundPort: 4001
    },
    staging: {
      protocol: 'https',
      subdomain: 'www'
    },
    production: {
      protocol: 'https',
      subdomain: 'www'
    }
  },
  'merchandising-ui': {
    development: {
      protocol: 'https',
      subdomain: 'merchandising',
      boundPort: 9100
    },
    test: {
      protocol: 'https',
      subdomain: 'merchandising',
      boundPort: 9101
    },
    staging: {
      protocol: 'https',
      subdomain: 'merchandising'
    },
    production: {
      protocol: 'https',
      subdomain: 'merchandising'
    }
  },
  'ops-employees-api': {
    development: {
      protocol: 'https',
      subdomain: 'ops-employees-api',
      boundPort: 8010
    },
    test: {
      protocol: 'https',
      subdomain: 'ops-employees-api-test',
      boundPort: 8011
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops-employees-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops-employees-api'
    }
  },
  'ops-employees-ui': {
    development: {
      protocol: 'https',
      subdomain: 'ops-employees',
      boundPort: 8005
    },
    test: {
      protocol: 'https',
      subdomain: 'ops-employees-test',
      boundPort: 8006
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops-employees'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops-employees'
    }
  },
  'ops-purchase-orders-api': {
    development: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders-api',
      boundPort: 8030
    },
    test: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders-api-test',
      boundPort: 8031
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders-api'
    }
  },
  'ops-purchase-orders-ui': {
    development: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders',
      boundPort: 8025
    },
    test: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders-test',
      boundPort: 8026
    },
    staging: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders'
    },
    production: {
      protocol: 'https',
      subdomain: 'ops-purchase-orders'
    }
  },
  'orders-service': {
    development: {
      protocol: 'https',
      subdomain: 'orders-api',
      boundPort: 9220
    },
    test: {
      protocol: 'https',
      subdomain: 'orders-api-test',
      boundPort: 9221
    },
    staging: {
      protocol: 'https',
      subdomain: 'orders-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'orders-api'
    }
  },
  'portal-ui': {
    development: {
      protocol: 'https',
      subdomain: 'hub',
      boundPort: 9160
    },
    test: {
      protocol: 'https',
      subdomain: 'hub-test',
      boundPort: 9161
    },
    staging: {
      protocol: 'https',
      subdomain: 'hub'
    },
    production: {
      protocol: 'https',
      subdomain: 'hub'
    }
  },
  'product-feed': {
    development: {
      protocol: 'https',
      subdomain: 'product-feed',
      boundPort: 9210
    },
    test: {
      protocol: 'https',
      subdomain: 'product-feed-test',
      boundPort: 9211
    },
    staging: {
      protocol: 'https',
      subdomain: 'product-feed'
    },
    production: {
      protocol: 'https',
      subdomain: 'product-feed'
    }
  },
  'purchase-orders-api': {
    development: {
      protocol: 'https',
      subdomain: 'purchase-orders-api',
      boundPort: 8030
    },
    test: {
      protocol: 'https',
      subdomain: 'purchase-orders-api-test',
      boundPort: 8031
    },
    staging: {
      protocol: 'https',
      subdomain: 'purchase-orders-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'purchase-orders-api'
    }
  },
  'purchase-orders-ui': {
    development: {
      protocol: 'https',
      subdomain: 'purchase-orders',
      boundPort: 8025
    },
    test: {
      protocol: 'https',
      subdomain: 'purchase-orders-test',
      boundPort: 8026
    },
    staging: {
      protocol: 'https',
      subdomain: 'purchase-orders'
    },
    production: {
      protocol: 'https',
      subdomain: 'purchase-orders'
    }
  },
  // ideally all `riversand-api` entries would have a `path` of '/api'
  // there are limitations in goodeggs-http-api-contract-test-helper that make the use of this feature painful
  // (until that limitation is addressed). See https://github.com/goodeggs/goodeggs-sites/pull/25.
  // Note that there is only a `development` env because we do not have a staging instance of Riversand
  'riversand-api': {
    development: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    test: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    staging: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    production: {
      protocol: 'https',
      subdomain: 'goodeggs',
      domain: 'riversand.com'
    }
  },
  'riversand-ui': {
    development: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    test: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    staging: {
      protocol: 'https',
      subdomain: 'goodeggsfs',
      domain: 'riversand.com'
    },
    production: {
      protocol: 'https',
      subdomain: 'goodeggs',
      domain: 'riversand.com'
    }
  },
  'shipping-api': {
    development: {
      protocol: 'https',
      subdomain: 'shipping-api',
      boundPort: 9020
    },
    test: {
      protocol: 'https',
      subdomain: 'shipping-api-test',
      boundPort: 9021
    },
    staging: {
      protocol: 'https',
      subdomain: 'shipping-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'shipping-api'
    }
  },
  'sms-api': {
    development: {
      protocol: 'https',
      subdomain: 'sms-api',
      boundPort: 9150
    },
    test: {
      protocol: 'https',
      subdomain: 'sms-api-test',
      boundPort: 9151
    },
    staging: {
      protocol: 'https',
      subdomain: 'sms-api'
    },
    production: {
      protocol: 'https',
      subdomain: 'sms-api'
    }
  },
  'transcend-domain-events-adapter': {
    development: {
      protocol: 'https',
      subdomain: 'transcend-domain-events-adapter',
      boundPort: 9190
    },
    test: {
      protocol: 'https',
      subdomain: 'transcend-domain-events-adapter-test',
      boundPort: 9191
    },
    staging: {
      protocol: 'https',
      subdomain: 'transcend-domain-events-adapter'
    },
    production: {
      protocol: 'https',
      subdomain: 'transcend-domain-events-adapter'
    }
  }
}; // FIXME(ndhoule): This typing is not perfect, but I couldn't figure out how else to generate this.

var _default = sites;
exports.default = _default;
//# sourceMappingURL=site_list.js.map